// Auth API Service
import axios from 'axios';

const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:4001/api';

const api = axios.create({ baseURL: API_BASE });

// Add auth token to requests
api.interceptors.request.use((cfg) => {
    const token = localStorage.getItem('token');
    if (token) {
        cfg.headers.Authorization = `Bearer ${token}`;
    }
    return cfg;
});

export const authApi = {
    login: (email, password) =>
        api.post('/auth/login', { email, password }),

    register: (userData) =>
        api.post('/auth/register', userData),

    getProfile: () =>
        api.get('/auth/me'),

    updateProfile: (profileData) =>
        api.put('/auth/profile', profileData),
};
